"use strict";

const Config = {
  DOMAIN: process.env.DOMAIN,
  API_DOMAIN: process.env.API_DOMAIN,
  ETOOS_API_DOMAIN: process.env.ETOOS_API_DOMAIN,
  ETOOS_COOKIE_URL: process.env.ETOOS_COOKIE_URL,
  ETOOS_COOKIE_REMOVE_URL: process.env.ETOOS_COOKIE_REMOVE_URL,
  ETOOS_DORMANT_URL: process.env.ETOOS_DORMANT_URL,
  ETOOS_INFO: process.env.ETOOS_INFO,
  ETOOS_ECI_INFO: process.env.ETOOS_ECI_INFO,
  MATOMO_INFO: process.env.MATOMO_INFO,
  GTM_INFO: process.env.GTM_INFO,
  JSON_DOMAIN: process.env.JSON_DOMAIN,
  API_CURI_DOMAIN: process.env.API_CURI_DOMAIN,
  APPLE_SECRET_KEY: process.env.APPLE_SECRET_KEY,
  APPLE_INFO: process.env.APPLE_INFO,
  NAVER_CLIENT_ID: process.env.NAVER_CLIENT_ID,
  GOOGLE_SECRET_KEY: process.env.GOOGLE_SECRET_KEY,
  KAKAO_SECRET_KEY: process.env.KAKAO_SECRET_KEY,
  FACEBOOK_APP_ID: process.env.FACEBOOK_APP_ID,
  JUSO_KEY: process.env.JUSO_KEY,
  CLIENT_INFO: process.env.CLIENT_INFO,
  RECAPTCHA_KEY: process.env.RECAPTCHA_KEY,
  SCHOOL_API_KEY: process.env.SCHOOL_API_KEY,
  COOKIE_DOMAIN: process.env.COOKIE_DOMAIN,
  ZOCBO_COOKIE_URL: process.env.ZOCBO_COOKIE_URL,
  DEVICE_TYPE_COOKIE: "deviceType",
  DEVICE_TYPE: {
    PC: "pc",
    ANDROID: "android",
    IOS: "ios"
  },
  NATIVE_CALLBACK_TYPE: {
    CHANGE_PASSWORD: "WEBV001",
    WITHDRAW: "WEBV002",
    USER_UPDATE: "WEBV003",
    VALID_TOKEN_ERROR: "WEBV099"
  },
  SERVICE_CODE: {
    INTEGREATED: "SVC001",
    ETOOS: "SVC002",
    ZOCBO: "SVC003",
    GROUW: "SVC004",
    CURI: "SVC005",
    LINKER: "SVC006",
    SKYGO: "SVC007",
    ELIFUNT: "SVC008",
    WORD_MASTER: "SVC009",
    MOJI: "SVC010",
    ETOOS_ECI: "SVC011",
    DION: "SVC012"
  },
  LOGIN_SITE: {
    LOGIN: "LOS001",
    JOIN: "LOS002"
  },
  SIGN_IN_ID_TYPE: {
    ACCOUNT: "account",
    GOOGLE: "google",
    FACEBOOK: "facebook",
    APPLE: "apple",
    KAKAO: "kakao",
    NAVER: "naver"
  },
  SIGN_UP_TYPE: {
    EMAIL: "EMAIL",
    PHONE: "PHONE",
    SOCIAL: "SOCIAL"
  },
  ID_TYPE: {
    EMAIL: "IDT001",
    PHONE: "IDT002",
    FACEBOOK: "IDT003",
    KAKAO: "IDT004",
    NAVER: "IDT005",
    GOOGLE: "IDT006",
    APPLE: "IDT007",
    ETOOS: "IDT008"
  },
  SOCIAL_TYPE: {
    FACEBOOK: "SOC001",
    KAKAO: "SOC002",
    NAVER: "SOC003",
    GOOGLE: "SOC004",
    APPLE: "SOC005"
  },
  USER_TYPE: {
    SKYGO: {
      SMALL_STUDENT: "MST015",
      TEACHER: "MST014",
      BIG_STUDENT: "MST013"
    }
  },
  VERIFY_SEND_TYPE: {
    EMAIL: "PST001",
    PHONE: "PST002"
  },
  USE_TYPE: {
    SIGN_UP: "AUT001", // 회원가입
    PASSWORD_INIT: "AUT002", // 비밀번호 초기화
    PHONE_POSSESSION: "AUT003", // 핸드폰 점유, 핸드폰 아이디 추가
    SERVICE_REGISTER: "AUT004", // 서비스 등록
    INTEGRATED_WITHDRAWAL: "AUT005", // 통합회원 탈퇴
    SERVICE_TERMINATION: "AUT006", // 서비스 해지
    INTEGRATED_WITHDRAWAL_CANCEL: "AUT007", // 통합회원 탈퇴 철회
    SERVICE_TERMINATION_CANCEL: "AUT008", // 서비스 해지 철회
    PASSWORD_LOCK_CANCEL: "AUT011", // 비밀번호잠금해제
    ID_EMAIL_ADD: "AUT012", //이메일ID추가
    CHANGE_PROFILE_EMAIL: "AUT013", //프로필 이메일 변경
    CHANGE_PROFILE_PHONE: "AUT014", //프로필 휴대폰 변경
    UPDATE_MY_NAME: "AUT015", // 내 이름 변경
    FIND_ACCOUNT_ID: "AUT019", // 계정 아이디 찾기
    FIND_ACCOUNT_PASSWORD: "AUT020" // 계정 비밀번호 찾기
  },
  EXTRA_COOKIE: ["refreshTokenInter", "accessTokenInter", "integratedMemberYn", "token", "hipid"],
  VISANG_INFO: {
    CLIENT_ID_NON_LIVE: "b53ce43a54b608c9abd3c233074553e1",
    CLIENT_SECRET_NON_LIVE: "8b39e23c73049e0af94a072ec5ac84e4f54815ea139a1d7068093af351836b57",
    CLIENT_ID_LIVE: "ddfc2d8d65eac4130dcba37fdc217f2b",
    CLIENT_SECRET_LIVE: "6e38b8c8774a452257d617057ab7050e2e6adc46a59d222a914635e2ab11f17e"
  },
  DEVICE_HASH: "device_hash",
  IS_TEACHER: "isTeacher"
};

export default Config;
